import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import { createLead } from "@/lib/api";

export const LeadForm = ({ goalKg = null, compact = false, source = "form" }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [consent, setConsent] = useState(true);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || phone.trim().length < 7) {
      toast.error("Podaj imię oraz poprawny numer telefonu.");
      return;
    }
    if (!consent) {
      toast.error("Zaznacz zgodę na kontakt telefoniczny.");
      return;
    }
    setLoading(true);
    try {
      await createLead({ name: name.trim(), phone: phone.trim(), goal_kg: goalKg, consent });
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "generate_lead", {
          currency: "PLN",
          value: 1,
          form_source: source,
          goal_kg: goalKg || undefined,
        });
      }
      setDone(true);
      toast.success("Dziękujemy! Oddzwonimy do Ciebie w ciągu 24h.");
    } catch (err) {
      toast.error("Coś poszło nie tak. Spróbuj ponownie.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="lead-form-success"
        className="border border-[#2A2626] bg-[#1A1718] p-10 md:p-12"
      >
        <p className="font-display text-4xl md:text-5xl text-[#FF6B6B] leading-none">
          Zapisane.
        </p>
        <p className="mt-4 text-muted max-w-md">
          Twoje zgłoszenie do nas dotarło{name ? `, ${name}` : ""}. Trenerka oddzwoni w ciągu 24
          godzin i ustali dogodny termin pierwszego treningu w Zdrofit Stegny.
        </p>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="contact-form"
      className={`border border-[#2A2626] bg-[#1A1718] ${compact ? "p-8" : "p-10 md:p-12"}`}
    >
      <div className="space-y-6">
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-muted mb-3">Imię</label>
          <input
            data-testid="lead-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Twoje imię"
            className="w-full bg-transparent border-b border-[#2A2626] py-3 text-lg text-[#F5F2F0] outline-none focus:border-[#FF6B6B] transition-colors"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-muted mb-3">
            Numer telefonu
          </label>
          <input
            data-testid="lead-phone-input"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+48 600 000 000"
            inputMode="tel"
            className="w-full bg-transparent border-b border-[#2A2626] py-3 text-lg text-[#F5F2F0] outline-none focus:border-[#FF6B6B] transition-colors"
          />
        </div>
        <label className="flex items-start gap-3 cursor-pointer select-none">
          <input
            data-testid="lead-consent-checkbox"
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            className="mt-1 accent-[#FF6B6B] w-4 h-4"
          />
          <span className="text-sm text-muted leading-relaxed">
            Wyrażam zgodę na kontakt telefoniczny w sprawie treningów personalnych.
          </span>
        </label>
        <button
          type="submit"
          data-testid="lead-submit-button"
          disabled={loading}
          className="btn-primary w-full rounded-full py-4 px-8 font-semibold text-sm uppercase tracking-[0.15em] flex items-center justify-center gap-3 disabled:opacity-60"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" /> Wysyłam...
            </>
          ) : (
            <>
              Chcę zacząć <ArrowRight className="w-4 h-4" />
            </>
          )}
        </button>
        <p className="text-xs text-muted text-center">
          Bez spamu. Jeden telefon, żeby ustalić termin.
        </p>
      </div>
    </form>
  );
};
